import Image from 'next/image';
import React, { Component } from 'react';
import Select from 'react-select';

import categorySearchBackground from '../../../static/images/category-search-bg.jpg';

const selectStyles = { menu: styles => ({ ...styles, zIndex: 9999 }) };
const customStyles = {
	menuList: (provided, state) => ({
		...provided,
		// maxHeight: '200px',
	}),
	control: (provided, state) => ({
		...provided,
		background: '#fff',
		minHeight: '40px',
		height: '40px',
		borderRadius: '3px',
		borderWidth: '2px',
	}),

	valueContainer: (provided, state) => ({
		...provided,
		height: '40px',
	}),

	input: (provided, state) => ({
		...provided,
		margin: '0px',
	}),

	indicatorsContainer: (provided, state) => ({
		...provided,
		height: '40px',
	}),
};

const customStylesActive = {
	menuList: (provided, state) => ({
		...provided,
		// maxHeight: '200px',
	}),
	control: (provided, state) => ({
		...provided,
		background: '#fff',
		minHeight: '40px',
		height: '40px',
		borderRadius: '3px',
		borderWidth: '2px',
		borderColor: '#96cb57',
	}),

	valueContainer: (provided, state) => ({
		...provided,
		height: '40px',
		color: 'green',
	}),

	input: (provided, state) => ({
		...provided,
		margin: '0px',
	}),

	placeholder: (provided, state) => ({
		...provided,
		fontWeight: '600',
		color: '#96cb57',
	}),

	indicatorsContainer: (provided, state) => ({
		...provided,
		height: '40px',
	}),
};

class CategorySearch extends Component {
	render() {
		const { type, names, dropdownCategories, formTitle, updatingOptionId, application, imageUrl } = this.props;
		let lastIndexAvailable = dropdownCategories.length - 1;

		return (
			<div
				className={`category-search ${type} `}
				style={{
					background: `#395e95 url(${categorySearchBackground}) center center`,
				}}>
				<div className="inner-wrapper">
					<div className={`${type === 'cover' ? 'container' : ''}`}>
						{type === 'cover' && (
							<div className="brand">
								<Image objectFit="contain" width="100px" height="100px" src={imageUrl} alt="category" />
							</div>
						)}

						<div className="form">
							{/* <h4>{formTitle}</h4> */}
							<div className="form-items">
								{names.map((item, index) => {
									var selectedId = application ? application[index] : null;
									var selectedItem = null;

									if (dropdownCategories[index] && selectedId) {
										selectedItem = dropdownCategories[index].find(el => el.id == selectedId.id);
									}

									return (
										<div
											className={`
                        form-item 
                        ${!dropdownCategories[index] ? 'disabled' : ''}
                        ${updatingOptionId === index ? 'loading' : ''}
                        ${lastIndexAvailable === index ? 'last-index-available' : ''}
                      `}
											key={index}>
											{updatingOptionId === index && (
												<div className="loading-container">
													<div className="inner">
														<i className="fas fa-circle-notch fa-spin mr-2"></i> Loading...
													</div>
												</div>
											)}

											<Select
												styles={
													lastIndexAvailable === index ? customStylesActive : customStyles
												}
												defaultValue={selectedItem}
												value={selectedItem}
												isDisabled={!dropdownCategories[index]}
												id={`select-${item}`}
												closeMenuOnSelect={true}
												blurInputOnSelect={true}
												getOptionLabel={({ name }) => name}
												getOptionValue={({ id }) => id}
												options={dropdownCategories[index]}
												placeholder={item}
												onChange={value => {
													this.props.onSelectionChange(value, index);
												}}
											/>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CategorySearch;
